import { createAction } from '@ngrx/store';

export const resetState = createAction('[Global] Reset State');
